export const selectMilestones = (state) =>
  state.companyMilestone?.milestones || [];

export const selectMilestonesLoading = (state) =>
  state.companyMilestone?.loading || false;

export const selectMilestonesError = (state) =>
  state.companyMilestone?.error || null;

export const selectMilestoneCreating = (state) =>
  state.companyMilestone?.creating || false;

export const selectSelectedMilestone = (state) =>
  state.companyMilestone?.selectedMilestone || null;

export const selectMilestoneDetailsLoading = (state) =>
  state.companyMilestone?.detailsLoading || false;

export const selectMilestoneDetailsError = (state) =>
  state.companyMilestone?.detailsError || null;